import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'

function ModalTotalQualityControl () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                Learn more
            </Button>
            {/* <a href="/" className="btn btn-link right-icon" >Learn more <i className="icon icon-minimal-right"></i></a> */}
    
            <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Total Quality Control</Modal.Title>
            </Modal.Header>
            <Modal.Body>Solusi yang mendukung tercapainya No Defect dan produk yang selalu berkualitas dalam setiap proses kerja dengan implementasi IT dan teknologi digital lainnya.</Modal.Body>
                <Modal.Footer>
                    <a 
                    style={{"color":"#fff"}}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/watch?v=BOfh-VQHqIE">
                        <button className="btn btn-primary" >
                            Keynotes Video
                        </button>
                    </a>
                </Modal.Footer>
            </Modal>
        </div>
    );
}


export default ModalTotalQualityControl
